import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLogin: false,
    token: "",
    AdminCache: "",
	TabObj: '',
	listenMessage: false,
	isExam: false,
	theme: '#409EFF', //element-ui默认主题（蓝色）
	themeStyle: {},
	parameter:{},
	mainAppMethods:{}
  },
  mutations: {
		// 更新登录状态  
		changeLoginState(state, isLoginOk) {
			state.isLogin = isLoginOk;
		},
		changeExam(state, isExam) {
			state.isExam = !state.isExam
		},
		upListenMessage(state, payload) {
			state.listenMessage = payload;
		},
		// 存储token
		saveTokenStorage(state, payload) {
			state.token = payload;
		},
		//存储用户信息
		saveUserInfoStorage(state, payload) {
			state.AdminCache = payload;
		},
		//存储窗口打开信息
		saveTabObj(state, payload) {
			state.TabObj = payload;
		},
		//存储配置信息
		saveAllConfigStorage(state, payload) {
			state.allConfig = payload;
		},
		// 更新token
		updateToken(state, payload) {
			
			state.token = {
				'RefreshToken': payload.RefreshToken,
				'AccessToken': payload.AccessToken,
				'AccessExpiresIn': payload.AccessExpiresIn
			}
			sessionStorage.setItem('token', JSON.stringify(state.token))
		},
		// 主题色更换的样式
		changeThemeColor(state, value) {
			state.themeStyle = value;
		},
		// 更新主题色
		changeGlobalTheme(state, value) {
			state.theme = value;
		},
		updateParameter(state, value) {
			state.parameter = value;
		},
		setMainAddTab(state, methods) {
			state.mainAppMethods = methods;
	  	},
  },
  actions: {},
  modules: {},
});
